import React from "react";

export default function ResourceYoutubeLink({
    youtubeLink,
    index,
    handleRemoveYoutubeLink,
    addYoutubeLink,
}) {
    function handleChange(changes) {
        addYoutubeLink(index, { ...youtubeLink, ...changes });
    }

    return (
        <div className="field is-grouped is-expanded">
            <p className="control is-expanded">
                <input
                    value={youtubeLink.link}
                    className="input"
                    type="text"
                    placeholder="Youtube video URL"
                    name="link"
                    onChange={(e) => handleChange({ link: e.target.value })}
                />
            </p>
            <p className="control">
                <button
                    className="button is-outlined is-danger"
                    onClick={(e) => {
                        e.preventDefault();
                        handleRemoveYoutubeLink(index);
                    }}
                >
                    Remove
                </button>
            </p>
        </div>
    );
}
